import { Box } from "@mui/material";
import React from "react";
import vid from "../assets/Header/cover-vid.mp4"
import logo from './../assets/Logo/logo.png'
import './Header.css'
function Header() {
    return (
        <>

            <div className="appHead">
                <img src={logo} className="App-logo" alt="logo" />

            </div>
            <div className="header">
                <div>
                    <Box className='videoBg' sx={{ display: 'flex', mt: '15px' }} >
                        <video autoPlay={true} muted src={vid} loop width={'100%'}>
                            Your browser does not support the video tag.
                        </video>
                    </Box>
                </div>
            </div>
        </>
    );
}

export default Header;
